import styled from 'styled-components';
import { BP_MOBILE_MAX } from '../../../assets/styles/breakpoints';

export default styled.div`
  width: calc(50% - 55px);
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  @media (max-width: ${BP_MOBILE_MAX}px) {
    width: 100%;
  }
`;

export const CategoryHeadlineSC = styled.h2`
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 0px;
`;

export const FaqLinkSC = styled.a`
  cursor: pointer;
  font-size: 16px;
  font-weight: normal;
  padding: 10px 0;
  width: 100%;
  border-bottom: 1px solid #e9e9e9;
  text-decoration: none;
  &:hover {
    border-bottom: 1px solid #8e885b;
    transition: all 0.3s;
  }
`;
